import { tns } from "tiny-slider/src/tiny-slider"
import {SmallBlockSlider} from "@blax-modules/base-front-end/resources/js/sliders/smallblock-slider";

/**
 * Used in careers slider
 */

let careerSliderEl = document.querySelector('.careers-slider');
if(careerSliderEl != null){

    let sliderAUtoplay = (careerSliderEl.getAttribute('data-autoplay') == 'auto') ? true : false;
    let sliderSpeed = careerSliderEl.getAttribute('data-speed');

    const CAREERS_SLIDER = {
        container: ".careers-slider",
        autoplayTimeout: sliderSpeed,
        autoplay: sliderAUtoplay,
    }

    document.addEventListener('DOMContentLoaded', () => {
        new SmallBlockSlider(CAREERS_SLIDER);
    })
}

